import { render, staticRenderFns } from "./courseEdit.vue?vue&type=template&id=908d914a&"
import script from "./courseEdit.vue?vue&type=script&lang=js&"
export * from "./courseEdit.vue?vue&type=script&lang=js&"
import style0 from "./courseEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports